import { createContext, useContext, useState } from 'react';

const EditModeContext = createContext();

export function EditModeProvider({ children }) {
  const [editMode, setEditMode] = useState('off');

  return (
    <EditModeContext.Provider value={{ editMode, setEditMode }}>
      {children}
    </EditModeContext.Provider>
  );
}

export function useEditMode() {
  return useContext(EditModeContext);
}
